import React from "react";
import { Link } from "react-router-dom";
import { Construction } from "lucide-react";

export default function Placeholder({ title, description }) {
  return (
    <main className="dyntra-container py-20 text-center">
      <div className="h-16 w-16 rounded-2xl bg-[#F3EFFC] flex items-center justify-center mx-auto mb-5">
        <Construction className="h-8 w-8 text-[#4B2AAD]" />
      </div>
      <h1 className="font-display text-3xl font-bold text-gray-900">{title}</h1>
      <p className="text-gray-500 mt-2 max-w-md mx-auto">{description || "This section is under construction. Come back soon for the full experience."}</p>
      <Link to="/" className="dyntra-btn-primary mt-6 inline-flex">Back to Home</Link>
    </main>
  );
}
